import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpService } from '../http/http.service';
import { apiConstant } from '../constant/apiConstant';
import { Router} from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class OutlookService {
  errMessage:any;
  isError: boolean = false;
  private initialQueryParams: any = null; 

  constructor(private httpService: HttpService,private router: Router) {}
  getConsentRequired(){
    return this.httpService.get(`${environment.baseUrl}${apiConstant.consent}/ConsentRequired`);
  }
  
  getConsentUrl(stateId:any) {
    return this.httpService.get(`${environment.baseUrl}${apiConstant.consent}/ConsentUrl?stateId=${stateId}`);
  }

  postSysCache(body: any) {
    return this.httpService.post(`${environment.baseUrl}${apiConstant.sysCache}`, body);
  }

  getAppBaseUrl(): string {
    const { protocol, hostname, port } = window.location;
    let baseUrl = `${protocol}//${hostname}`;
    if (port) {
      baseUrl += `:${port}`;
    }
    return baseUrl;
  }

  getSysCache(msConsentCallbackStateId:string){
    return this.httpService.get(`${environment.baseUrl}${apiConstant.sysCache}/${msConsentCallbackStateId}?retain=false`);
  }

  
  setError(err: any) {
    this.errMessage = err;
    this.isError = true;
  }

  async handleConsent(baseURL:string, routerURL:string,msConsentQueryParams:string) {
    try {
      const cacheBody = { data: baseURL + routerURL };
      const cacheResponse = await this.postSysCache(cacheBody).toPromise();
      const stateId = cacheResponse.result;
  
      const urlResponse = await this.getConsentUrl(stateId).toPromise();
      const consentUrl = urlResponse.result;
  
      if (consentUrl) {
        window.open(consentUrl, '_self');
        this.getSysCache(msConsentQueryParams).subscribe((res: any) => {
        });
      } else {
        this.setError(['Consent URL is undefined or null']);
      }
    } catch (err: any) {
      if (err.error && err.error.result && err.error.result.errorMessages && err.error.result.errorMessages.length > 0) {
        this.setError(err.error.result.errorMessages);
      } else {
        this.setError(['Internal Server Error.']);
      }
    }
  }

    setMsConcentQueryParams(params: any) {
      if (!this.initialQueryParams) {
        this.initialQueryParams = { ...params };
      }
    }
  
    getMsConcentQueryParams() {
      return this.initialQueryParams;
    }

    clearQueryParams() {
      this.initialQueryParams = null; 
    }

}
